import NewsDetailLayout from '../NewsDetailLayout';
import { kigasuruData } from '../newsDetailData';

const KigasuruDetail = () => <NewsDetailLayout data={kigasuruData} />;
export default KigasuruDetail;
